<template>
    <div class="flex-row mt-3 animated fadeIn">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col sm="12" md="12" lg="10" xl="12">
                    <b-card-group>
                        <b-card no-body>
                            <b-card-body class="pb-0">
                                <div class="text-center">
                                    <img
                                        src="img/logo-login.png"
                                        alt="app-logo"
                                        class="mb-4"
                                    />
                                    <h1 class="mb-4">{{ appDescr }}</h1>
                                </div>
                                <div class="text-center">
                                    <h3>SOLICITAÇÃO DE ACESSO</h3>
                                </div>
                                <app-erros-box
                                    :erros="erros"
                                    v-if="erros.length > 0"
                                ></app-erros-box>
                                <div class="mt-4" v-if="etapa == '0'">
                                    <h5 class="heading-1">
                                        <span>TIPO DO ACESSO</span>
                                    </h5>
                                    <b-row class="mb-2">
                                        <b-col>
                                            <b-form-group>
                                                <b-form-radio-group
                                                    v-model="tipoAcesso"
                                                >
                                                    <b-form-radio :value="1">
                                                        <strong>
                                                            <span
                                                                >PESSOA
                                                                JURÍDICA</span
                                                            >
                                                        </strong>
                                                    </b-form-radio>
                                                    <b-form-radio :value="2">
                                                        <strong>
                                                            <span
                                                                >PESSOA
                                                                FÍSICA</span
                                                            >
                                                        </strong>
                                                    </b-form-radio>
                                                </b-form-radio-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <div v-if="tipoAcesso == 1">
                                        <h5 class="heading-1">
                                            <span>DADOS DO FORNECEDOR</span>
                                        </h5>
                                        <b-row class="mt-3">
                                            <b-col sm="12" md="12">
                                                <b-form-group>
                                                    <label class="required">Logo</label>
                                                    <div class="d-flex align-items-center">
                                                        <img v-if="logo.preview && logo.preview !== 'img/placeholder-logo.png'" :src="logo.preview" alt="Logo" class="mr-3" style="width: 150px; height: 150px; object-fit: contain;">
                                                        <div v-else style="width: 150px; height: 150px; border: 1px dashed #ccc; display: flex; align-items: center; justify-content: center; color: #666; margin-right: 1rem;">
                                                           Pré-visualização da logo
                                                        </div>
                                                        <div class="d-flex flex-column align-items-start">
                                                            <div class="d-flex">
                                                                <b-button @click="triggerLogoUpload" variant="primary" class="mr-2">
                                                                    Selecionar Arquivo
                                                                </b-button>
                                                                <b-button @click="removeLogo" variant="danger" v-if="logo.preview && logo.preview !== 'img/placeholder-logo.png'">
                                                                    Remover Logo
                                                                </b-button>
                                                            </div>
                                                            <input type="file" ref="logoFileInput" @change="handleLogoChange" accept="image/png, image/svg+xml" class="d-none">
                                                            <small class="form-text text-muted mt-2">
                                                                A imagem deve ter no máximo 1024x1024px e 2MB.
                                                            </small>
                                                            <b-form-invalid-feedback :state="!logoError">
                                                                {{ logoError }}
                                                            </b-form-invalid-feedback>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="12" md="4">
                                                <b-form-group>
                                                    <label class="required"
                                                        >CNPJ do
                                                        Fornecedor</label
                                                    >
                                                    <b-form-input
                                                        type="text"
                                                        v-model="
                                                            cpfCnpjFornecedor
                                                        "
                                                        @input.native="
                                                            $v.cpfCnpjFornecedor.$touch()
                                                        "
                                                        :state="
                                                            $v.cpfCnpjFornecedor
                                                                .$error
                                                                ? false
                                                                : null
                                                        "
                                                        v-mask="[
                                                            '##.###.###/####-##'
                                                        ]"
                                                    ></b-form-input>
                                                    <b-form-invalid-feedback
                                                        v-if="!$v.cpfCnpjFornecedor.isPresente"
                                                        >CNPJ do fornecedor é
                                                        obrigatório</b-form-invalid-feedback
                                                    >
                                                    <b-form-invalid-feedback
                                                        v-if="$v.cpfCnpjFornecedor.isPresente && !$v.cpfCnpjFornecedor.cnpjValido"
                                                        >CNPJ do fornecedor inválido/não
                                                        existe</b-form-invalid-feedback
                                                    >
                                                </b-form-group>
                                            </b-col>
                                            <b-col sm="12" md="8">
                                                <b-form-group>
                                                    <label class="required"
                                                        >Razão Social</label
                                                    >
                                                    <b-form-input
                                                        type="text"
                                                        v-model="
                                                            razaoSocialFornecedor
                                                        "
                                                        @input="
                                                            $v.razaoSocialFornecedor.$touch()
                                                        "
                                                        :state="
                                                            $v
                                                                .razaoSocialFornecedor
                                                                .$error
                                                                ? false
                                                                : null
                                                        "
                                                    ></b-form-input>
                                                    <b-form-invalid-feedback
                                                        >A Razão Social do
                                                        fornecedor é
                                                        obrigatória</b-form-invalid-feedback
                                                    >
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col sm="12" md="6">
                                                <b-form-group>
                                                    <label class="required"
                                                        >E-mail</label
                                                    >
                                                    <b-form-input
                                                        type="text"
                                                        v-model="
                                                            emailFornecedor
                                                        "
                                                        @input="
                                                            $v.emailFornecedor.$touch()
                                                        "
                                                        :state="
                                                            $v.emailFornecedor
                                                                .$error
                                                                ? false
                                                                : null
                                                        "
                                                    ></b-form-input>
                                                    <b-form-invalid-feedback
                                                        >Forneça um email
                                                        válido</b-form-invalid-feedback
                                                    >
                                                </b-form-group>
                                            </b-col>
                                            <b-col sm="12" md="3">
                                                <b-form-group>
                                                    <label class="required"
                                                        >Telefone</label
                                                    >
                                                    <b-form-input
                                                        maxlength="15"
                                                        type="text"
                                                        v-model="
                                                            telefone01Fornecedor
                                                        "
                                                        @input="
                                                            $v.telefone01Fornecedor.$touch()
                                                        "
                                                        :state="
                                                            $v
                                                                .telefone01Fornecedor
                                                                .$error
                                                                ? false
                                                                : null
                                                        "
                                                        v-mask="[
                                                            '(##) ####-####',
                                                            '(##) #####-####'
                                                        ]"
                                                    ></b-form-input>
                                                    <b-form-invalid-feedback
                                                        >O telefone do
                                                        fornecedor é
                                                        obrigatório</b-form-invalid-feedback
                                                    >
                                                </b-form-group>
                                            </b-col>
                                            <b-col sm="12" md="3">
                                                <b-form-group>
                                                    <label>Celular</label>
                                                    <b-form-input
                                                        maxlength="15"
                                                        type="text"
                                                        v-model="
                                                            telefone02Fornecedor
                                                        "
                                                        v-mask="[
                                                            '(##) ####-####',
                                                            '(##) #####-####'
                                                        ]"
                                                    ></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <!-- <b-row>
                                            <b-col>
                                                <b-form-group>
                                                    <label class="required">
                                                        Já é fornecedor do
                                                        Sebrae?
                                                    </label>
                                                    <b-form-radio-group
                                                        v-model="
                                                            fornecedorSebrae
                                                        "
                                                    >
                                                        <b-form-radio
                                                            :value="true"
                                                        >
                                                            <strong>
                                                                <span>SIM</span>
                                                            </strong>
                                                        </b-form-radio>
                                                        <b-form-radio
                                                            :value="false"
                                                        >
                                                            <strong>
                                                                <span>NÃO</span>
                                                            </strong>
                                                        </b-form-radio>
                                                    </b-form-radio-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row> -->
                                    </div>
                                    <h5 class="heading-1">
                                        <span>DADOS DO USUÁRIO</span>
                                    </h5>
                                    <b-row>
                                        <b-col sm="12" md="4">
                                            <b-form-group>
                                                <label class="required"
                                                    >CPF do Usuário</label
                                                >
                                                <b-form-input
                                                    type="text"
                                                    v-model="cpfUsuario"
                                                    @input.native="
                                                        $v.cpfUsuario.$touch()
                                                    "
                                                    :state="
                                                        $v.cpfUsuario.$error
                                                            ? false
                                                            : null
                                                    "
                                                    v-mask="'###.###.###-##'"
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    v-if="!$v.cpfUsuario.required"
                                                    >CPF do usuário é
                                                    obrigatório</b-form-invalid-feedback
                                                >
                                                <b-form-invalid-feedback
                                                    v-if="$v.cpfUsuario.required && !$v.cpfUsuario.cpfValido"
                                                    >CPF do usuário inválido/não
                                                    existe</b-form-invalid-feedback
                                                >
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="8">
                                            <b-form-group>
                                                <label class="required"
                                                    >Nome do Usuário</label
                                                >
                                                <b-form-input
                                                    type="text"
                                                    v-model="nomeUsuario"
                                                    @input="
                                                        $v.nomeUsuario.$touch()
                                                    "
                                                    :state="
                                                        $v.nomeUsuario.$error
                                                            ? false
                                                            : null
                                                    "
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    >O nome do usuário é
                                                    obrigatório</b-form-invalid-feedback
                                                >
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="12" md="6">
                                            <b-form-group>
                                                <label class="required"
                                                    >E-mail</label
                                                >
                                                <b-form-input
                                                    type="text"
                                                    v-model="emailUsuario"
                                                    @input="
                                                        $v.emailUsuario.$touch()
                                                    "
                                                    :state="
                                                        $v.emailUsuario.$error
                                                            ? false
                                                            : null
                                                    "
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    >Forneça um email
                                                    válido</b-form-invalid-feedback
                                                >
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="3">
                                            <b-form-group>
                                                <label class="required"
                                                    >Telefone</label
                                                >
                                                <b-form-input
                                                    maxlength="15"
                                                    type="text"
                                                    v-model="telefone01Usuario"
                                                    @input="
                                                        $v.telefone01Usuario.$touch()
                                                    "
                                                    :state="
                                                        $v.telefone01Usuario
                                                            .$error
                                                            ? false
                                                            : null
                                                    "
                                                    v-mask="[
                                                        '(##) ####-####',
                                                        '(##) #####-####'
                                                    ]"
                                                ></b-form-input>
                                                <b-form-invalid-feedback
                                                    >O telefone do usuário é
                                                    obrigatório</b-form-invalid-feedback
                                                >
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="3">
                                            <b-form-group>
                                                <label>Celular</label>
                                                                                                <b-form-input
                                                                                                    maxlength="15"
                                                                                                    type="text"
                                                                                                    v-model="telefone02Usuario"
                                                                                                    v-mask="[
                                                                                                        '(##) ####-####',
                                                                                                        '(##) #####-####'
                                                                                                    ]"
                                                                                                ></b-form-input>
                                                                                                </b-form-group>
                                                                                            </b-col>
                                                                                        </b-row>
                                                                                    </div>
                                                                                <div class="mt-4" v-if="etapa == '1'"></div>
                            </b-card-body>
                            <b-card-footer>
                                <b-button
                                    variant="primary"
                                    @click.stop="solicitarAcesso()"
                                    class="mr-2"
                                    v-if="mostrarBtnSolicitarAcesso"
                                >
                                    <i class="fa fa-save"></i> Solicitar Acesso
                                </b-button>
                                <b-button
                                    variant="danger"
                                    @click.stop="voltar()"
                                    class="mr-2"
                                >
                                    <span>
                                        <i class="fa fa-history"></i> Voltar
                                    </span>
                                </b-button>
                                <div class="float-right" v-if="etapa == 0">
                                    <label class="required ml-3 pt-2"></label>
                                    <label class="ml-2 pt-2"
                                        >Campos Obrigatórios</label
                                    >
                                </div>
                            </b-card-footer>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {
    required,
    email,
    minLength,
    minValue,
    helpers
} from 'vuelidate/lib/validators'
import SolicitacoesAcessoServicos from './SolicitacoesAcessoServicos'
import FornecedoresServicos from '../../fornecedores/FornecedoresServicos'

const isPresente = (param) => (value) => param == 1 ? !helpers.req(value) : true

export default {
    data() {
        return {
            appNome: process.env.VUE_APP_NOME,
            appDescr: process.env.VUE_APP_DESCR,
            erros: [],
            cpfCnpjFornecedor: '',
            razaoSocialFornecedor: '',
            emailFornecedor: '',
            telefone01Fornecedor: '',
            telefone02Fornecedor: '',
            cpfUsuario: '',
            nomeUsuario: '',
            emailUsuario: '',
            telefone01Usuario: '',
            telefone02Usuario: '',
            etapa: 0,
            tipoAcesso: 1,
            fornecedorSebrae: true,
            logo: {
                base64: null,
                file: null,
                preview: 'img/placeholder-logo.png'
            },
            logoError: null
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Login' })
        },

        handleLogoChange(event) {
            const file = event.target.files[0]
            if (!file) {
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
                this.logoError = null;
                return;
            }

            this.logoError = null; // Clear previous errors

            // File type validation (PNG and SVG allowed)
            const allowedTypes = ['image/png', 'image/svg+xml'];
            if (!allowedTypes.includes(file.type)) {
                this.$toast.error('Formato de arquivo não suportado. Por favor, envie apenas imagens PNG e SVG.', 'Erro', this.$toastConfig.error);
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
                return;
            }

            // File size validation (Max 2MB)
            const maxFileSize = 2 * 1024 * 1024; // 2MB
            if (file.size > maxFileSize) {
                const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                this.$toast.error(`O arquivo selecionado é muito grande (${fileSizeMB} MB). O limite máximo permitido é de 2MB.`, 'Erro', this.$toastConfig.error);
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
                return;
            }

            const reader = new FileReader()
            reader.onload = (e) => {
                const img = new Image()
                img.onload = () => {
                    // Image resolution validation (Max 1024x1024px)
                    const maxResolution = 1024;
                    if (img.width > maxResolution || img.height > maxResolution) {
                        this.$toast.error(`A resolução da imagem excede o limite permitido de ${maxResolution}x${maxResolution} pixels.`, 'Erro', this.$toastConfig.error);
                        this.logo.preview = 'img/placeholder-logo.png';
                        this.logo.base64 = null;
                        return;
                    } else {
                        this.logo.preview = e.target.result
                        this.logo.base64 = e.target.result
                    }
                }
                img.onerror = () => {
                    this.$toast.error('Não foi possível carregar a imagem selecionada. O arquivo pode estar corrompido ou o formato é inválido.', 'Erro', this.$toastConfig.error);
                    this.logo.preview = 'img/placeholder-logo.png';
                    this.logo.base64 = null;
                };
                img.src = e.target.result
            }
            reader.onerror = () => {
                this.$toast.error('Não foi possível ler o arquivo. Tente novamente mais tarde.', 'Erro', this.$toastConfig.error);
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
            };
            reader.readAsDataURL(file)
        },

        triggerLogoUpload() {
            // Since this is a new application request, there won't be an "existing" logo
            // from the backend to consider replacement. So, we directly open the file selector.
            this.$refs.logoFileInput.click();
        },

        removeLogo() {
            this.logo.file = null;
            this.logo.base64 = null;
            this.logo.preview = 'img/placeholder-logo.png'; // Reset to placeholder
            // Clear any logo errors
            this.logoError = null;
            // If the input element holds a file, clear it
            if (this.$refs.logoFileInput) {
                this.$refs.logoFileInput.value = '';
            }
        },

        solicitarAcesso() {
            this.$store.dispatch('addRequest')
            let solicitacaoAcesso
            if (this.tipoAcesso == 1) {
                solicitacaoAcesso = {
                    cpfCnpjFornecedor: this.cpfCnpjFornecedor.apenasNumeros(),
                    razaoSocialFornecedor:
                        this.razaoSocialFornecedor.toUpperCase(),
                    emailFornecedor: this.emailFornecedor.toLowerCase(),
                    telefone01Fornecedor:
                        this.telefone01Fornecedor.apenasNumeros(),
                    telefone02Fornecedor:
                        this.telefone02Fornecedor.apenasNumeros(),
                    cpfUsuario: this.cpfUsuario.apenasNumeros(),
                    nomeUsuario: this.nomeUsuario.toUpperCase(),
                    emailUsuario: this.emailUsuario.toLowerCase(),
                    telefone01Usuario: this.telefone01Usuario.apenasNumeros(),
                    telefone02Usuario: this.telefone02Usuario.apenasNumeros(),
                    tipoAcesso: this.tipoAcesso,
                    fornecedorSebrae: this.fornecedorSebrae,
                    logo: this.logo.base64
                }
            } else {
                solicitacaoAcesso = {
                    cpfUsuario: this.cpfUsuario.apenasNumeros(),
                    nomeUsuario: this.nomeUsuario.toUpperCase(),
                    emailUsuario: this.emailUsuario.toLowerCase(),
                    telefone01Usuario: this.telefone01Usuario.apenasNumeros(),
                    telefone02Usuario: this.telefone02Usuario.apenasNumeros(),
                    tipoAcesso: this.tipoAcesso
                }
            }

            SolicitacoesAcessoServicos.solicitarAcesso(solicitacaoAcesso).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                            this.$store.dispatch('removeRequest')
                        } else {
                            this.erros = response.errors
                            this.$store.dispatch('removeRequest')
                        }
                    } else {
                        this.$store.dispatch('removeRequest')
                    }
                }
            )
        },

        registroSalvoComSucesso() {
            this.$swal({
                title: 'Solicitação de acesso realizada com sucesso',
                html: `Após o processamento da sua solicitação,
        você receberá um email com os dados de acesso ao ESPAÇO DO FORNECEDOR.`,
                icon: 'success'
            }).then((result) => {
                this.voltar()
            })
        }
    },

    computed: {
        mostrarBtnSolicitarAcesso() {
            return !this.$v.$invalid && this.etapa == 0 && !this.logoError
        }
    },

    watch: {},

    created() {},

    validations: {
        cpfCnpjFornecedor: {
            isPresente(value) {
                return this.tipoAcesso == 1 ? helpers.req(value) : true
            },
            cnpjValido(value) {
                return this.tipoAcesso == 1
                    ? this.$cnpjValido(value.apenasNumeros())
                    : true
            }
        },
        razaoSocialFornecedor: {
            isPresente(value) {
                return this.tipoAcesso == 1 ? helpers.req(value) : true
            }
        },
        emailFornecedor: {
            isPresente(value) {
                return this.tipoAcesso == 1 ? helpers.req(value) : true
            },
            email(value) {
                return this.tipoAcesso == 1 ? email(value) : true
            }
        },
        telefone01Fornecedor: {
            isPresente(value) {
                return this.tipoAcesso == 1 ? helpers.req(value) : true
            },
            tamanho() {
                return this.tipoAcesso == 1 ? minLength(14) : true
            }
        },
        fornecedorSebrae: {
            isFornecedorSebrae() {
                return this.tipoAcesso == 1
                    ? this.fornecedorSebrae == true ||
                          this.fornecedorSebrae == false
                    : true
            }
        },
        cpfUsuario: {
            required,
            cpfValido(value) {
                return this.$cpfValido(value.apenasNumeros())
            }
        },
        nomeUsuario: {
            required
        },
        emailUsuario: {
            required,
            email
        },
        telefone01Usuario: {
            required,
            minLength: minLength(14)
        },
        logo: {
            base64: {
                isPresente(value) {
                    return this.tipoAcesso == 1 ? value !== null : true
                }
            }
        }
    }
}
</script>
